export enum FEES {
  single_use_cup_fee = '',
}

export enum FEE_TYPE {
  BAG_FEE = 'bagFee',
}
